import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    TemplateRef,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@klickdata/core/auth';
import { AppScope } from '@klickdata/core/resource';
import { Utils } from '@klickdata/core/util';
import { UserAllowedResourcesService } from '@klickdata/home/src/shared/user-allowed-resources.service';
import { filter, map, startWith, switchMap, tap } from 'rxjs/operators';
export interface GenericTabsOption {
    label: string;
    url: string;
    value: string;
    index: number;
    scope?: AppScope;
    data?: any;
}
@Component({
    selector: 'app-generic-mobile-tabs',
    templateUrl: './generic-mobile-tabs.component.html',
    styleUrls: ['./generic-mobile-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericMobileTabsComponent implements OnInit {
    private _activeOption: GenericTabsOption;
    @Input() options: GenericTabsOption[];
    @Input() isNavTab = true;
    @Input() fetchActiveOptionFromRoute = false;
    @ContentChildren(TemplateRef) templateRefs: QueryList<TemplateRef<any>>;
    @Output()
    public selectedOption: EventEmitter<GenericTabsOption> = new EventEmitter();
    @Input()
    public set activeOption(activeOption: GenericTabsOption) {
        this._activeOption = activeOption;
    }
    public get activeOption(): GenericTabsOption {
        return this._activeOption;
    }
    @Input() wrapperClass: string;

    constructor(private cdr: ChangeDetectorRef, private router: Router, protected auth: AuthService) {}
    public ngOnInit() {
        this.getActiveOption();
        if (this.fetchActiveOptionFromRoute) {
            this.router.events
                .pipe(filter((event) => event instanceof NavigationEnd))
                .subscribe(() => this.getActiveOption());
        }
        this.auth
            .getNK3Platform()
            .pipe(
                filter((platform) => platform == 'user' || platform == 'guest'),
                switchMap(() => this.auth.getCustomer()),
                map((customer) =>
                    !!customer.authoring_allowed_types?.length &&
                    customer.authoring_allowed_types?.includes(AppScope.RESOURCES)
                        ? this.options
                        : [
                              ...this.options.filter((opt) => !opt.scope),
                              ...this.options.filter(
                                  (opt) =>
                                      opt.scope &&
                                      !!customer.authoring_allowed_types?.length &&
                                      customer.authoring_allowed_types?.includes(opt.scope)
                              ),
                          ]
                )
            )
            .subscribe((options) => {
                this.options = options;
                this.cdr.markForCheck();
            });
    }
    private getActiveOption() {
        this.activeOption = Utils.getSelectedMobileTabsOption(this.router, this.options);
        this.cdr.markForCheck();
    }
}
